module.exports = __webpack_public_path__ + "static/polar-footerBanner-a7ac30f78cb94782fbfa1c662415c259.jpg";